<template>
  <div :class="wrapperClass">
    <v-tooltip
      v-if="mini"
      :data-testid="`${testIdPrefix}__support-tooltip`"
      right
      content-class="tooltip-right"
    >
      <template #activator="{ on, attrs }">
        <v-list-item
          v-if="useWidget"
          :data-testid="`${testIdPrefix}__support-button`"
          v-bind="attrs"
          v-on="on"
          :class="listItemClass"
          :aria-label="ariaLabel"
          @click.stop.prevent="handleClick"
        >
          <img
            :data-testid="`${testIdPrefix}__support-icon`"
            :src="iconSrc"
            :alt="iconAlt"
            class="nav-img-icon"
          />
        </v-list-item>
        <v-list-item
          v-else
          :data-testid="`${testIdPrefix}__support-link`"
          v-bind="attrs"
          v-on="on"
          :class="listItemClass"
          :aria-label="ariaLabel"
          :to="linkTarget"
          link
        >
          <img
            :data-testid="`${testIdPrefix}__support-icon`"
            :src="iconSrc"
            :alt="iconAlt"
            class="nav-img-icon"
          />
        </v-list-item>
      </template>
      <span :data-testid="`${testIdPrefix}__support-tooltip-text`">{{ label }}</span>
    </v-tooltip>

    <template v-else>
      <v-list-item
        v-if="useWidget"
        :data-testid="`${testIdPrefix}__support-button`"
        :class="listItemClass"
        :aria-label="ariaLabel"
        @click.stop.prevent="handleClick"
      >
        <img
          :data-testid="`${testIdPrefix}__support-icon`"
          :src="iconSrc"
          :alt="iconAlt"
          class="nav-img-icon"
        />
        <v-list-item-content
          :data-testid="`${testIdPrefix}__support-content`"
          class="pa-0 d-flex align-center"
        >
          <component
            :is="labelTag"
            :data-testid="`${testIdPrefix}__support-text`"
            :class="labelClass"
          >
            {{ label }}
          </component>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-else
        :data-testid="`${testIdPrefix}__support-link`"
        :class="listItemClass"
        :aria-label="ariaLabel"
        :to="linkTarget"
        link
      >
        <img
          :data-testid="`${testIdPrefix}__support-icon`"
          :src="iconSrc"
          :alt="iconAlt"
          class="nav-img-icon"
        />
        <v-list-item-content
          :data-testid="`${testIdPrefix}__support-content`"
          class="pa-0 d-flex align-center"
        >
          <component
            :is="labelTag"
            :data-testid="`${testIdPrefix}__support-text`"
            :class="labelClass"
          >
            {{ label }}
          </component>
        </v-list-item-content>
      </v-list-item>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SupportMenuItem',
  props: {
    mini: {
      type: Boolean,
      default: false
    },
    useWidget: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'Help & Support'
    },
    iconSrc: {
      type: String,
      default: '/img/navicon/Support.svg'
    },
    iconAlt: {
      type: String,
      default: 'Help & Support icon'
    },
    supportRoute: {
      type: [String, Object],
      default: null
    },
    testIdPrefix: {
      type: String,
      default: 'support-menu'
    },
    extraClasses: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    activeClass: {
      type: String,
      default: 'radius-small'
    },
    ariaLabel: {
      type: String,
      default: 'Help & Support'
    },
    labelTag: {
      type: String,
      default: 'v-list-item-title'
    },
    labelClass: {
      type: String,
      default: 'side-nav-text-color hide-when-mini text-truncate'
    },
    wrapperClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    listItemClass() {
      const classes = [
        'nav-standard-item',
        'd-flex',
        'align-center',
        this.useWidget ? 'cursor-pointer' : '',
        this.extraClasses
      ];
      if (this.active) {
        classes.push(this.activeClass);
      }
      return classes.join(' ').replace(/\s+/g, ' ').trim();
    },
    linkTarget() {
      if (!this.supportRoute) return null;
      if (typeof this.supportRoute === 'object') return this.supportRoute;
      const go = this.$nova?.gotoLink;
      if (typeof go === 'function') {
        return go({ path: this.supportRoute }, true);
      }
      return { path: this.supportRoute };
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>
